module.exports = __webpack_public_path__ + "static/media/modaaccessori.dd0471e4.png";